export const siteConfig = {
  brand: {
    name: "Dionara Krause",
    subtitle: "Estética e Nutrição",
    logo: "/assets/images/logo/Logo.png",
    logoAlt: "Dionara Krause logo",
    homePath: "/",
  },

  navigation: [
    { label: "Início", path: "/", end: true },
    { label: "Sobre", path: "/about" },
    { label: "Serviços", path: "/services" },
    { label: "Contato", path: "/contact" },
  ],
};
